// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: mujoL4gD3qd1ezKDLZ31rZ
// Component: ZgtgOwq6J5gf
import * as React from "react"
import { Link } from "gatsby"
import * as p from "@plasmicapp/react-web"
import {
  hasVariant,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
} from "@plasmicapp/react-web"
import Stripe from "../../Stripe" // plasmic-import: JaZPnDe4BQ/component
import Headline from "../../Headline" // plasmic-import: KiN_FJLYI1/component
import HeadlineButton from "../../HeadlineButton" // plasmic-import: uHRDF-VO-A/component
import IconButton from "../../IconButton" // plasmic-import: mEnM6zW3GD/component
import { useMode } from "./PlasmicGlobalVariant__Mode" // plasmic-import: zulsK3o-3W/globalVariant
import { useHighlight } from "./PlasmicGlobalVariant__Highlight" // plasmic-import: ntiwPmQAsH/globalVariant
import { useArrangement } from "./PlasmicGlobalVariant__Arrangement" // plasmic-import: hhgYSeu_QK/globalVariant
import { useScreenVariants as useScreenVariantsekypzdksLjd0F } from "./PlasmicGlobalVariant__Screen" // plasmic-import: EKYPZDKSLjd0F/globalVariant
import "@plasmicapp/react-web/lib/plasmic.css"
import * as projectcss from "./plasmic_jeffdo_es.module.css" // plasmic-import: mujoL4gD3qd1ezKDLZ31rZ/projectcss
import * as sty from "./PlasmicHomepage.module.css" // plasmic-import: ZgtgOwq6J5gf/css
import ThirtysixIcon from "./icons/PlasmicIcon__Thirtysix" // plasmic-import: PiVIGAVUm/icon
import TwentytwoIcon from "./icons/PlasmicIcon__Twentytwo" // plasmic-import: 4vkcnz2Ax/icon
import ArrowRightIcon from "./icons/PlasmicIcon__ArrowRight" // plasmic-import: iZuEl1jiaD/icon
import FaceIcon from "./icons/PlasmicIcon__Face" // plasmic-import: BZoH_3Sy18/icon
import InfoIcon from "./icons/PlasmicIcon__Info" // plasmic-import: 5Sy2g4y6V/icon
import PaintIcon from "./icons/PlasmicIcon__Paint" // plasmic-import: iy4A9uBWD/icon
import MapIcon from "./icons/PlasmicIcon__Map" // plasmic-import: i-ZGrNlsT/icon
import LearnaxIcon from "./icons/PlasmicIcon__Learnax" // plasmic-import: PH_4kYBwV/icon
import SprintsIcon from "./icons/PlasmicIcon__Sprints" // plasmic-import: 0hscHUcbO/icon
import TrackIcon from "./icons/PlasmicIcon__Track" // plasmic-import: GuFQhLpY5/icon
import EyeOpenIcon from "./icons/PlasmicIcon__EyeOpen" // plasmic-import: J7fJnmL4N/icon
import EyeClosedIcon from "./icons/PlasmicIcon__EyeClosed" // plasmic-import: aBAB-JPNq/icon
import JwSharpIcon from "./icons/PlasmicIcon__JwSharp" // plasmic-import: imnHY-_8sU/icon
import NightIcon from "./icons/PlasmicIcon__Night" // plasmic-import: nS7MqAdlwl/icon
import DayIcon from "./icons/PlasmicIcon__Day" // plasmic-import: 2cwRWiCxc/icon

export const PlasmicHomepage__VariantProps = new Array()

export const PlasmicHomepage__ArgProps = new Array("path")

function PlasmicHomepage__RenderFunc(props) {
  const { variants, args, overrides, forNode } = props
  const globalVariants = ensureGlobalVariants({
    mode: useMode(),
    highlight: useHighlight(),
    arrangement: useArrangement(),
    screen: useScreenVariantsekypzdksLjd0F(),
  })

  return (
    <React.Fragment>
      <style>{`
        body {
          margin: 0;
        }
      `}</style>

      <div className={projectcss.plasmic_page_wrapper}>
        <p.Stack
          as={"div"}
          data-plasmic-name={"root"}
          data-plasmic-override={overrides.root}
          data-plasmic-root={true}
          data-plasmic-for-node={forNode}
          hasGap={true}
          className={classNames(
            projectcss.all,
            projectcss.root_reset,
            projectcss.plasmic_default_styles,
            projectcss.plasmic_mixins,
            projectcss.plasmic_tokens,
            sty.root,
            {
              [projectcss.global_mode_dark]: hasVariant(
                globalVariants,
                "mode",
                "dark"
              ),

              [sty.rootglobal_arrangement_float]: hasVariant(
                globalVariants,
                "arrangement",
                "float"
              ),

              [sty.rootglobal_highlight_about]: hasVariant(
                globalVariants,
                "highlight",
                "about"
              ),

              [sty.rootglobal_highlight_work]: hasVariant(
                globalVariants,
                "highlight",
                "work"
              ),

              [sty.rootglobal_mode_dark]: hasVariant(
                globalVariants,
                "mode",
                "dark"
              ),

              [sty.rootglobal_mode_reveal]: hasVariant(
                globalVariants,
                "mode",
                "reveal"
              ),
            }
          )}
        >
          <p.PlasmicLink
            data-plasmic-name={"_36Dot22"}
            data-plasmic-override={overrides._36Dot22}
            className={classNames(projectcss.all, projectcss.a, sty._36Dot22, {
              [sty._36Dot22global_highlight_about]: hasVariant(
                globalVariants,
                "highlight",
                "about"
              ),

              [sty._36Dot22global_highlight_work]: hasVariant(
                globalVariants,
                "highlight",
                "work"
              ),

              [sty._36Dot22global_mode_dark]: hasVariant(
                globalVariants,
                "mode",
                "dark"
              ),

              [sty._36Dot22global_mode_reveal]: hasVariant(
                globalVariants,
                "mode",
                "reveal"
              ),
            })}
            component={Link}
            href={"/36dot22"}
            platform={"gatsby"}
            target={"_blank"}
            title={"36 Days of Type, 2022 Edition"}
          >
            {true ? (
              <p.Stack
                as={"div"}
                data-plasmic-name={"callout"}
                data-plasmic-override={overrides.callout}
                hasGap={true}
                className={classNames(projectcss.all, sty.callout, {
                  [sty.calloutglobal_highlight_about]: hasVariant(
                    globalVariants,
                    "highlight",
                    "about"
                  ),

                  [sty.calloutglobal_highlight_work]: hasVariant(
                    globalVariants,
                    "highlight",
                    "work"
                  ),

                  [sty.calloutglobal_mode_dark]: hasVariant(
                    globalVariants,
                    "mode",
                    "dark"
                  ),

                  [sty.calloutglobal_mode_reveal]: hasVariant(
                    globalVariants,
                    "mode",
                    "reveal"
                  ),
                })}
              >
                <div
                  data-plasmic-name={"freeBox"}
                  data-plasmic-override={overrides.freeBox}
                  className={classNames(projectcss.all, sty.freeBox, {
                    [sty.freeBoxglobal_highlight_work]: hasVariant(
                      globalVariants,
                      "highlight",
                      "work"
                    ),
                  })}
                >
                  <ThirtysixIcon
                    className={classNames(projectcss.all, sty.svg__kiQg6, {
                      [sty.svgglobal_highlight_work__kiQg6JCUoz]: hasVariant(
                        globalVariants,
                        "highlight",
                        "work"
                      ),
                    })}
                    role={"img"}
                  />

                  {true ? (
                    <TwentytwoIcon
                      className={classNames(projectcss.all, sty.svg__iqt6V, {
                        [sty.svgglobal_highlight_about__iqt6VjOrod]: hasVariant(
                          globalVariants,
                          "highlight",
                          "about"
                        ),

                        [sty.svgglobal_highlight_work__iqt6VjCUoz]: hasVariant(
                          globalVariants,
                          "highlight",
                          "work"
                        ),
                      })}
                      role={"img"}
                    />
                  ) : null}
                </div>

                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__ym5Bc,
                    {
                      [sty.textglobal_arrangement_float__ym5BcZZfig]:
                        hasVariant(globalVariants, "arrangement", "float"),
                      [sty.textglobal_highlight_about__ym5BcjOrod]: hasVariant(
                        globalVariants,
                        "highlight",
                        "about"
                      ),

                      [sty.textglobal_highlight_work__ym5BcjCUoz]: hasVariant(
                        globalVariants,
                        "highlight",
                        "work"
                      ),

                      [sty.textglobal_mode_dark__ym5BcJYvh]: hasVariant(
                        globalVariants,
                        "mode",
                        "dark"
                      ),

                      [sty.textglobal_mode_reveal__ym5Bcv94Jk]: hasVariant(
                        globalVariants,
                        "mode",
                        "reveal"
                      ),
                    }
                  )}
                >
                  {"Now serving \n36 days of type"}
                </div>

                <ArrowRightIcon
                  className={classNames(projectcss.all, sty.svg__hdgd, {
                    [sty.svgglobal_highlight_about__hdgdjOrod]: hasVariant(
                      globalVariants,
                      "highlight",
                      "about"
                    ),

                    [sty.svgglobal_highlight_work__hdgdjCUoz]: hasVariant(
                      globalVariants,
                      "highlight",
                      "work"
                    ),
                  })}
                  role={"img"}
                />
              </p.Stack>
            ) : null}
          </p.PlasmicLink>

          <Stripe
            data-plasmic-name={"likeness"}
            data-plasmic-override={overrides.likeness}
            category={"about"}
            className={classNames("__wab_instance", sty.likeness, {
              [sty.likenessglobal_arrangement_float]: hasVariant(
                globalVariants,
                "arrangement",
                "float"
              ),

              [sty.likenessglobal_highlight_about]: hasVariant(
                globalVariants,
                "highlight",
                "about"
              ),

              [sty.likenessglobal_highlight_work]: hasVariant(
                globalVariants,
                "highlight",
                "work"
              ),

              [sty.likenessglobal_mode_dark]: hasVariant(
                globalVariants,
                "mode",
                "dark"
              ),

              [sty.likenessglobal_mode_reveal]: hasVariant(
                globalVariants,
                "mode",
                "reveal"
              ),
            })}
            color={
              hasVariant(globalVariants, "screen", "desktopOnly")
                ? "mint"
                : "mint"
            }
            highlighted={
              hasVariant(globalVariants, "highlight", "about")
                ? true
                : undefined
            }
            icon={
              <FaceIcon
                className={classNames(projectcss.all, sty.svg__gvVi7)}
                role={"img"}
              />
            }
            label={"a likeness"}
            lowlighted={
              hasVariant(globalVariants, "highlight", "work") ? true : undefined
            }
            name={"likeness"}
          />

          <Stripe
            data-plasmic-name={"words"}
            data-plasmic-override={overrides.words}
            category={"about"}
            className={classNames("__wab_instance", sty.words, {
              [sty.wordsglobal_arrangement_float]: hasVariant(
                globalVariants,
                "arrangement",
                "float"
              ),

              [sty.wordsglobal_highlight_about]: hasVariant(
                globalVariants,
                "highlight",
                "about"
              ),

              [sty.wordsglobal_highlight_work]: hasVariant(
                globalVariants,
                "highlight",
                "work"
              ),

              [sty.wordsglobal_mode_dark]: hasVariant(
                globalVariants,
                "mode",
                "dark"
              ),

              [sty.wordsglobal_mode_reveal]: hasVariant(
                globalVariants,
                "mode",
                "reveal"
              ),
            })}
            color={"yellow"}
            highlighted={
              hasVariant(globalVariants, "highlight", "about")
                ? true
                : undefined
            }
            icon={
              <InfoIcon
                className={classNames(projectcss.all, sty.svg__iok3E)}
                role={"img"}
              />
            }
            label={
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__oP3Fs,
                  {
                    [sty.textglobal_mode_reveal__oP3FSv94Jk]: hasVariant(
                      globalVariants,
                      "mode",
                      "reveal"
                    ),
                  }
                )}
              >
                {"some words"}
              </div>
            }
            lowlighted={
              hasVariant(globalVariants, "highlight", "work") ? true : undefined
            }
            name={"words"}
          />

          <Headline
            data-plasmic-name={"headline"}
            data-plasmic-override={overrides.headline}
            className={classNames("__wab_instance", sty.headline, {
              [sty.headlineglobal_arrangement_float]: hasVariant(
                globalVariants,
                "arrangement",
                "float"
              ),

              [sty.headlineglobal_highlight_about]: hasVariant(
                globalVariants,
                "highlight",
                "about"
              ),

              [sty.headlineglobal_mode_dark]: hasVariant(
                globalVariants,
                "mode",
                "dark"
              ),

              [sty.headlineglobal_mode_reveal]: hasVariant(
                globalVariants,
                "mode",
                "reveal"
              ),
            })}
            end={
              <HeadlineButton
                data-plasmic-name={"design"}
                data-plasmic-override={overrides.design}
                className={classNames("__wab_instance", sty.design, {
                  [sty.designglobal_highlight_about]: hasVariant(
                    globalVariants,
                    "highlight",
                    "about"
                  ),

                  [sty.designglobal_highlight_work]: hasVariant(
                    globalVariants,
                    "highlight",
                    "work"
                  ),

                  [sty.designglobal_mode_dark]: hasVariant(
                    globalVariants,
                    "mode",
                    "dark"
                  ),

                  [sty.designglobal_mode_reveal]: hasVariant(
                    globalVariants,
                    "mode",
                    "reveal"
                  ),
                })}
                color={"purple"}
                label={
                  hasVariant(globalVariants, "highlight", "work")
                    ? "close product design"
                    : "† product design"
                }
                symbol={
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__p8Pzp,
                      {
                        [sty.textglobal_highlight_work__p8PzPjCUoz]: hasVariant(
                          globalVariants,
                          "highlight",
                          "work"
                        ),
                      }
                    )}
                  >
                    {"†"}
                  </div>
                }
                word={"design"}
              />
            }
            first={
              <HeadlineButton
                data-plasmic-name={"jeff"}
                data-plasmic-override={overrides.jeff}
                className={classNames("__wab_instance", sty.jeff, {
                  [sty.jeffglobal_arrangement_float]: hasVariant(
                    globalVariants,
                    "arrangement",
                    "float"
                  ),

                  [sty.jeffglobal_highlight_about]: hasVariant(
                    globalVariants,
                    "highlight",
                    "about"
                  ),

                  [sty.jeffglobal_highlight_work]: hasVariant(
                    globalVariants,
                    "highlight",
                    "work"
                  ),

                  [sty.jeffglobal_mode_dark]: hasVariant(
                    globalVariants,
                    "mode",
                    "dark"
                  ),

                  [sty.jeffglobal_mode_reveal]: hasVariant(
                    globalVariants,
                    "mode",
                    "reveal"
                  ),
                })}
                color={"purple"}
                label={
                  hasVariant(globalVariants, "highlight", "about")
                    ? "close about jeff"
                    : "* about jeff"
                }
                symbol={
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__r5O0R,
                      {
                        [sty.textglobal_highlight_about__r5O0RjOrod]:
                          hasVariant(globalVariants, "highlight", "about"),
                        [sty.textglobal_mode_reveal__r5O0Rv94Jk]: hasVariant(
                          globalVariants,
                          "mode",
                          "reveal"
                        ),
                      }
                    )}
                  >
                    {hasVariant(globalVariants, "highlight", "about")
                      ? "*"
                      : "*"}
                  </div>
                }
                word={"Jeff"}
              />
            }
          />

          <Stripe
            data-plasmic-name={"ui"}
            data-plasmic-override={overrides.ui}
            category={"work"}
            className={classNames("__wab_instance", sty.ui, {
              [sty.uiglobal_arrangement_float]: hasVariant(
                globalVariants,
                "arrangement",
                "float"
              ),

              [sty.uiglobal_highlight_about]: hasVariant(
                globalVariants,
                "highlight",
                "about"
              ),

              [sty.uiglobal_highlight_work]: hasVariant(
                globalVariants,
                "highlight",
                "work"
              ),

              [sty.uiglobal_mode_reveal]: hasVariant(
                globalVariants,
                "mode",
                "reveal"
              ),
            })}
            color={"orange"}
            highlighted={
              hasVariant(globalVariants, "highlight", "work") ? true : undefined
            }
            icon={
              <PaintIcon
                className={classNames(projectcss.all, sty.svg__laIzF)}
                role={"img"}
              />
            }
            label={"ui design"}
            lowlighted={
              hasVariant(globalVariants, "highlight", "about")
                ? true
                : undefined
            }
            name={"ui"}
          />

          <Stripe
            data-plasmic-name={"ux"}
            data-plasmic-override={overrides.ux}
            category={"work"}
            className={classNames("__wab_instance", sty.ux, {
              [sty.uxglobal_arrangement_float]: hasVariant(
                globalVariants,
                "arrangement",
                "float"
              ),

              [sty.uxglobal_highlight_about]: hasVariant(
                globalVariants,
                "highlight",
                "about"
              ),

              [sty.uxglobal_highlight_work]: hasVariant(
                globalVariants,
                "highlight",
                "work"
              ),

              [sty.uxglobal_mode_dark]: hasVariant(
                globalVariants,
                "mode",
                "dark"
              ),

              [sty.uxglobal_mode_reveal]: hasVariant(
                globalVariants,
                "mode",
                "reveal"
              ),
            })}
            color={"blue"}
            highlighted={
              hasVariant(globalVariants, "highlight", "work") ? true : undefined
            }
            icon={
              <MapIcon
                className={classNames(projectcss.all, sty.svg__ff02)}
                role={"img"}
              />
            }
            label={
              true ? (
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__raQdW
                  )}
                >
                  {"ux design"}
                </div>
              ) : null
            }
            lowlighted={
              hasVariant(globalVariants, "highlight", "about")
                ? true
                : undefined
            }
            name={"ux"}
          />

          <Stripe
            data-plasmic-name={"learnin"}
            data-plasmic-override={overrides.learnin}
            category={"about"}
            className={classNames("__wab_instance", sty.learnin, {
              [sty.learninglobal_arrangement_float]: hasVariant(
                globalVariants,
                "arrangement",
                "float"
              ),

              [sty.learninglobal_highlight_about]: hasVariant(
                globalVariants,
                "highlight",
                "about"
              ),

              [sty.learninglobal_highlight_work]: hasVariant(
                globalVariants,
                "highlight",
                "work"
              ),

              [sty.learninglobal_mode_reveal]: hasVariant(
                globalVariants,
                "mode",
                "reveal"
              ),
            })}
            color={"purple"}
            highlighted={
              hasVariant(globalVariants, "highlight", "about")
                ? true
                : undefined
            }
            icon={
              <LearnaxIcon
                className={classNames(projectcss.all, sty.svg__ofC2X)}
                role={"img"}
              />
            }
            label={"tools and learnins"}
            lowlighted={
              hasVariant(globalVariants, "highlight", "work") ? true : undefined
            }
            name={"learnin"}
          />

          <Stripe
            data-plasmic-name={"service"}
            data-plasmic-override={overrides.service}
            category={"work"}
            className={classNames("__wab_instance", sty.service, {
              [sty.serviceglobal_arrangement_float]: hasVariant(
                globalVariants,
                "arrangement",
                "float"
              ),

              [sty.serviceglobal_highlight_about]: hasVariant(
                globalVariants,
                "highlight",
                "about"
              ),

              [sty.serviceglobal_highlight_work]: hasVariant(
                globalVariants,
                "highlight",
                "work"
              ),

              [sty.serviceglobal_mode_dark]: hasVariant(
                globalVariants,
                "mode",
                "dark"
              ),

              [sty.serviceglobal_mode_reveal]: hasVariant(
                globalVariants,
                "mode",
                "reveal"
              ),
            })}
            color={"grey"}
            highlighted={
              hasVariant(globalVariants, "highlight", "work") ? true : undefined
            }
            icon={
              <SprintsIcon
                className={classNames(projectcss.all, sty.svg__hgkau)}
                role={"img"}
              />
            }
            label={
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__e0Mp7,
                  {
                    [sty.textglobal_highlight_work__e0Mp7JCUoz]: hasVariant(
                      globalVariants,
                      "highlight",
                      "work"
                    ),
                  }
                )}
              >
                {"service design"}
              </div>
            }
            lowlighted={
              hasVariant(globalVariants, "highlight", "about")
                ? true
                : undefined
            }
            name={"service"}
          />

          <Stripe
            data-plasmic-name={"tracks"}
            data-plasmic-override={overrides.tracks}
            category={"about"}
            className={classNames("__wab_instance", sty.tracks, {
              [sty.tracksglobal_arrangement_float]: hasVariant(
                globalVariants,
                "arrangement",
                "float"
              ),

              [sty.tracksglobal_highlight_about]: hasVariant(
                globalVariants,
                "highlight",
                "about"
              ),

              [sty.tracksglobal_highlight_work]: hasVariant(
                globalVariants,
                "highlight",
                "work"
              ),

              [sty.tracksglobal_mode_reveal]: hasVariant(
                globalVariants,
                "mode",
                "reveal"
              ),
            })}
            color={"red"}
            highlighted={
              hasVariant(globalVariants, "highlight", "about")
                ? true
                : undefined
            }
            icon={
              <TrackIcon
                className={classNames(projectcss.all, sty.svg__xhEae)}
                role={"img"}
              />
            }
            label={"leaving tracks"}
            lowlighted={
              hasVariant(globalVariants, "highlight", "work") ? true : undefined
            }
            name={"tracks"}
          />

          {true ? (
            <div
              data-plasmic-name={"nav"}
              data-plasmic-override={overrides.nav}
              className={classNames(projectcss.all, sty.nav, {
                [sty.navglobal_arrangement_float]: hasVariant(
                  globalVariants,
                  "arrangement",
                  "float"
                ),

                [sty.navglobal_highlight_about]: hasVariant(
                  globalVariants,
                  "highlight",
                  "about"
                ),

                [sty.navglobal_highlight_work]: hasVariant(
                  globalVariants,
                  "highlight",
                  "work"
                ),

                [sty.navglobal_mode_dark]: hasVariant(
                  globalVariants,
                  "mode",
                  "dark"
                ),
              })}
            >
              <IconButton
                data-plasmic-name={"reveal"}
                data-plasmic-override={overrides.reveal}
                className={classNames("__wab_instance", sty.reveal, {
                  [sty.revealglobal_highlight_work]: hasVariant(
                    globalVariants,
                    "highlight",
                    "work"
                  ),

                  [sty.revealglobal_mode_reveal]: hasVariant(
                    globalVariants,
                    "mode",
                    "reveal"
                  ),
                })}
                icon={
                  <p.PlasmicIcon
                    PlasmicIconType={
                      hasVariant(globalVariants, "mode", "reveal")
                        ? EyeClosedIcon
                        : EyeOpenIcon
                    }
                    className={classNames(projectcss.all, sty.svg__tyr6, {
                      [sty.svgglobal_mode_reveal__tyr6V94Jk]: hasVariant(
                        globalVariants,
                        "mode",
                        "reveal"
                      ),
                    })}
                    cursor={"pointer"}
                    role={"img"}
                  />
                }
                label={
                  hasVariant(globalVariants, "mode", "reveal")
                    ? "hide labels"
                    : "reveal labels"
                }
              />

              <p.PlasmicLink
                data-plasmic-name={"home"}
                data-plasmic-override={overrides.home}
                className={classNames(projectcss.all, projectcss.a, sty.home, {
                  [sty.homeglobal_mode_dark]: hasVariant(
                    globalVariants,
                    "mode",
                    "dark"
                  ),

                  [sty.homeglobal_mode_reveal]: hasVariant(
                    globalVariants,
                    "mode",
                    "reveal"
                  ),
                })}
                component={Link}
                href={args.path !== undefined ? args.path : "/design"}
                id={"logo"}
                platform={"gatsby"}
                title={"jeff wade"}
              >
                <IconButton
                  data-plasmic-name={"logo"}
                  data-plasmic-override={overrides.logo}
                  className={classNames("__wab_instance", sty.logo, {
                    [sty.logoglobal_mode_dark]: hasVariant(
                      globalVariants,
                      "mode",
                      "dark"
                    ),

                    [sty.logoglobal_mode_reveal]: hasVariant(
                      globalVariants,
                      "mode",
                      "reveal"
                    ),
                  })}
                  icon={
                    <p.PlasmicIcon
                      PlasmicIconType={
                        hasVariant(globalVariants, "mode", "dark")
                          ? JwSharpIcon
                          : JwSharpIcon
                      }
                      className={classNames(projectcss.all, sty.svg___1A3Bw, {
                        [sty.svgglobal_mode_dark___1A3BwJYvh]: hasVariant(
                          globalVariants,
                          "mode",
                          "dark"
                        ),

                        [sty.svgglobal_mode_reveal___1A3Bwv94Jk]: hasVariant(
                          globalVariants,
                          "mode",
                          "reveal"
                        ),
                      })}
                      role={"img"}
                    />
                  }
                  label={"jeff wade"}
                />
              </p.PlasmicLink>

              <IconButton
                data-plasmic-name={"darkmode"}
                data-plasmic-override={overrides.darkmode}
                className={classNames("__wab_instance", sty.darkmode, {
                  [sty.darkmodeglobal_mode_dark]: hasVariant(
                    globalVariants,
                    "mode",
                    "dark"
                  ),

                  [sty.darkmodeglobal_mode_reveal]: hasVariant(
                    globalVariants,
                    "mode",
                    "reveal"
                  ),
                })}
                icon={
                  <p.PlasmicIcon
                    PlasmicIconType={
                      hasVariant(globalVariants, "mode", "dark")
                        ? DayIcon
                        : NightIcon
                    }
                    className={classNames(projectcss.all, sty.svg___9Ekg, {
                      [sty.svgglobal_mode_dark___9EkgJYvh]: hasVariant(
                        globalVariants,
                        "mode",
                        "dark"
                      ),

                      [sty.svgglobal_mode_reveal___9Ekgv94Jk]: hasVariant(
                        globalVariants,
                        "mode",
                        "reveal"
                      ),
                    })}
                    cursor={"pointer"}
                    role={"img"}
                  />
                }
                label={
                  hasVariant(globalVariants, "mode", "dark")
                    ? "switch to light mode"
                    : "switch to dark mode"
                }
              />
            </div>
          ) : null}
        </p.Stack>
      </div>
    </React.Fragment>
  )
}

const PlasmicDescendants = {
  root: [
    "root",
    "_36Dot22",
    "callout",
    "freeBox",
    "likeness",
    "words",
    "headline",
    "design",
    "jeff",
    "ui",
    "ux",
    "learnin",
    "service",
    "tracks",
    "nav",
    "reveal",
    "home",
    "logo",
    "darkmode",
  ],

  _36Dot22: ["_36Dot22", "callout", "freeBox"],
  callout: ["callout", "freeBox"],
  freeBox: ["freeBox"],
  likeness: ["likeness"],
  words: ["words"],
  headline: ["headline", "design", "jeff"],
  design: ["design"],
  jeff: ["jeff"],
  ui: ["ui"],
  ux: ["ux"],
  learnin: ["learnin"],
  service: ["service"],
  tracks: ["tracks"],
  nav: ["nav", "reveal", "home", "logo", "darkmode"],
  reveal: ["reveal"],
  home: ["home", "logo"],
  logo: ["logo"],
  darkmode: ["darkmode"],
}

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = deriveRenderOpts(props, {
      name: nodeName,
      descendantNames: [...PlasmicDescendants[nodeName]],
      internalArgPropNames: PlasmicHomepage__ArgProps,
      internalVariantPropNames: PlasmicHomepage__VariantProps,
    })

    return PlasmicHomepage__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName,
    })
  }
  if (nodeName === "root") {
    func.displayName = "PlasmicHomepage"
  } else {
    func.displayName = `PlasmicHomepage.${nodeName}`
  }
  return func
}

export const PlasmicHomepage = Object.assign(
  // Top-level PlasmicHomepage renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    _36Dot22: makeNodeComponent("_36Dot22"),
    callout: makeNodeComponent("callout"),
    freeBox: makeNodeComponent("freeBox"),
    likeness: makeNodeComponent("likeness"),
    words: makeNodeComponent("words"),
    headline: makeNodeComponent("headline"),
    design: makeNodeComponent("design"),
    jeff: makeNodeComponent("jeff"),
    ui: makeNodeComponent("ui"),
    ux: makeNodeComponent("ux"),
    learnin: makeNodeComponent("learnin"),
    service: makeNodeComponent("service"),
    tracks: makeNodeComponent("tracks"),
    nav: makeNodeComponent("nav"),
    reveal: makeNodeComponent("reveal"),
    home: makeNodeComponent("home"),
    logo: makeNodeComponent("logo"),
    darkmode: makeNodeComponent("darkmode"),
    // Metadata about props expected for PlasmicHomepage
    internalVariantProps: PlasmicHomepage__VariantProps,
    internalArgProps: PlasmicHomepage__ArgProps,
  }
)

export default PlasmicHomepage
/* prettier-ignore-end */
